(function () {
  var closeAll = function (exceptWrap) {
    document.querySelectorAll('.fluevog-footer__select-wrap[data-open]').forEach(function (wrap) {
      if (wrap === exceptWrap) return;
      wrap.removeAttribute('data-open');
      var trigger = wrap.querySelector('.fluevog-footer__select-trigger');
      var menu = wrap.querySelector('.fluevog-footer__select-menu');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      if (menu) menu.hidden = true;
    });
  };

  var enhanceSelect = function (select) {
    if (!(select instanceof HTMLSelectElement) || select.dataset.fvEnhanced) return;
    var wrap = select.closest('.fluevog-footer__select-wrap');
    if (!wrap) return;

    select.dataset.fvEnhanced = 'true';
    select.setAttribute('tabindex', '-1');

    var trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'fluevog-footer__select-trigger fluevog-footer__settings-value';
    trigger.setAttribute('aria-haspopup', 'listbox');
    trigger.setAttribute('aria-expanded', 'false');
    var ariaLabel = select.getAttribute('aria-label');
    if (ariaLabel) trigger.setAttribute('aria-label', ariaLabel);

    var listId = 'fv-footer-select-' + Math.random().toString(36).slice(2);
    trigger.setAttribute('aria-controls', listId);

    var menu = document.createElement('ul');
    menu.className = 'fluevog-footer__select-menu';
    menu.id = listId;
    menu.setAttribute('role', 'listbox');
    menu.hidden = true;

    var syncFromSelect = function () {
      var selected = select.options[select.selectedIndex];
      trigger.textContent = selected ? selected.textContent.replace(/\s+/g, ' ').trim() : '';
      Array.prototype.forEach.call(menu.children, function (item, index) {
        item.setAttribute('aria-selected', select.selectedIndex === index ? 'true' : 'false');
      });
    };

    Array.prototype.forEach.call(select.options, function (option, index) {
      var item = document.createElement('li');
      item.className = 'fluevog-footer__select-option';
      item.setAttribute('role', 'option');
      item.tabIndex = -1;
      item.textContent = option.textContent.replace(/\s+/g, ' ').trim();
      item.addEventListener('click', function (event) {
        event.preventDefault();
        select.selectedIndex = index;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        syncFromSelect();
        closeAll();
        trigger.focus();
      });
      menu.appendChild(item);
    });

    var caret = wrap.querySelector('.icon-caret');
    wrap.insertBefore(trigger, caret || select.nextSibling);
    wrap.appendChild(menu);
    wrap.setAttribute('data-fv-enhanced-wrap', '');
    syncFromSelect();

    var positionMenu = function () {
      var rect = trigger.getBoundingClientRect();
      menu.style.position = 'fixed';
      menu.style.left = rect.left + 'px';
      menu.style.top = rect.bottom + 6 + 'px';
      menu.style.minWidth = Math.max(rect.width, 120) + 'px';
      menu.style.right = 'auto';
      menu.style.zIndex = '9999';
      var menuRect = menu.getBoundingClientRect();
      if (menuRect.right > window.innerWidth - 8) {
        menu.style.left = Math.max(8, window.innerWidth - menuRect.width - 8) + 'px';
      }
      if (menuRect.bottom > window.innerHeight - 8 && rect.top > menuRect.height + 6) {
        menu.style.top = rect.top - menuRect.height - 6 + 'px';
      }
    };

    var open = function () {
      closeAll(wrap);
      wrap.setAttribute('data-open', '');
      trigger.setAttribute('aria-expanded', 'true');
      menu.hidden = false;
      positionMenu();
      var selected = menu.querySelector('[aria-selected="true"]') || menu.firstElementChild;
      if (selected) selected.focus();
    };

    var close = function () {
      wrap.removeAttribute('data-open');
      trigger.setAttribute('aria-expanded', 'false');
      menu.hidden = true;
    };

    window.addEventListener('resize', function () {
      if (!menu.hidden) positionMenu();
    });
    window.addEventListener(
      'scroll',
      function () {
        if (!menu.hidden) positionMenu();
      },
      true
    );

    trigger.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      if (menu.hidden) open();
      else close();
    });

    trigger.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        event.preventDefault();
        open();
      }
    });

    menu.addEventListener('keydown', function (event) {
      var items = Array.prototype.slice.call(menu.querySelectorAll('[role="option"]'));
      var index = items.indexOf(document.activeElement);
      if (event.key === 'Escape') {
        event.preventDefault();
        close();
        trigger.focus();
      } else if (event.key === 'ArrowDown') {
        event.preventDefault();
        items[Math.min(index + 1, items.length - 1)].focus();
      } else if (event.key === 'ArrowUp') {
        event.preventDefault();
        items[Math.max(index - 1, 0)].focus();
      } else if (event.key === 'Home') {
        event.preventDefault();
        items[0].focus();
      } else if (event.key === 'End') {
        event.preventDefault();
        items[items.length - 1].focus();
      } else if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        if (document.activeElement) document.activeElement.click();
      } else if (event.key === 'Tab') {
        close();
      }
    });
  };

  var init = function () {
    document.querySelectorAll('.fluevog-footer__native-select').forEach(enhanceSelect);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);

  if (!window.__fvFooterSelectOutsideBound) {
    window.__fvFooterSelectOutsideBound = true;
    document.addEventListener('pointerdown', function (event) {
      var target = event.target;
      if (!(target instanceof Element)) {
        closeAll();
        return;
      }
      closeAll(target.closest('.fluevog-footer__select-wrap'));
    });
  }

  // Country/language change handling lives in fv-localization-switch.js so the
  // footer and the header drawer share one implementation.
})();
